import { createAllActions } from '@src/api/createRequestStore';
import { INIT, SET_TAB, FORM_TYPES, LIST_SCOPE, LIST_TYPES, SET_SORT_BY} from './types';

export const init = () => ({
  type: INIT,
});

export const setActiveTab = (tab) => ({
  type: SET_TAB,
  tab,
});

export const setSortBy = (sortBy) => ({
  type: SET_SORT_BY,
  sortBy,
});

// form actions
export const initForm = () => ({
  type: FORM_TYPES.INIT,
});

export const setPolicies = (policies) => ({
  type: FORM_TYPES.SET_POLICIES,
  policies,
});

export const setActivationState = (activationState) => ({
  type: FORM_TYPES.SET_ACTIVATION_STATE,
  activationState,
});

export const setTriggerAt = (triggerAt) => ({
  type: FORM_TYPES.SET_TRIGGER_AT,
  triggerAt,
});

export const setNotes = (notes) => ({
  type: FORM_TYPES.SET_NOTES,
  notes,
});

export const setEmailIds = (emailIds) => ({
  type: FORM_TYPES.SET_EMAILS,
  emailIds,
});

export const resetForm = () => ({
  type: FORM_TYPES.RESET
});

export const saveSchedule = (doneCallback) => ({
  type: FORM_TYPES.SAVE_SCHEDULE,
  doneCallback
});

export const deleteSchedule = (doneCallback) => ({
  type: FORM_TYPES.DELETE_SCHEDULE,
  doneCallback
});

export const setFormLoading = (loading) => ({
  type: FORM_TYPES.SET_LOADING,
  loading,
});

export const setVisible = (visible) => ({
  type: FORM_TYPES.SET_VISIBLE,
  visible,
});

export const setForm = (form) => ({
  type: FORM_TYPES.SET_FORM,
  form,
});

// list actions
export const fetchListData = () => ({
  type: LIST_TYPES.FETCH_DATA,
});
export const { init: initList, fetching: fetchingList } = createAllActions(LIST_SCOPE);
